import React from "react";

export function Reports() {
  return (
    <div className="fqxi-shortcodes-reports"></div>
  );
}
